export default "/_next/static/ba6bd9f6f428639452a3dd299fe97a86.jpg";